import React from 'react';

import TextField from '../../../../forms/TextField';

export default function PlacementType() {
  return (
    <TextField
      name="icaNativeAd.placementType"
      label="Placement Type"
      rules={{
        required: 'Please enter a placement type.',
      }}
    />
  );
}
